import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { logout } from "./store/slices/pubLoginSlice";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.pubLogin.isLoggedIn);
  const dispatch = useDispatch();

  const idleTimeout = 15 * 60 * 1000; // 15 minutes

  // Memoize handleLogout to avoid recreating the function on every render
  const handleLogout = useCallback(() => {
    toast.warning("Session timed out. Please log in again.");
    
    // Delay the actual logout and redirect by 1 second to allow the toast to show
    setTimeout(() => {
      dispatch(logout());
    }, 3000); // Delay for 3 second
  }, [dispatch]);

  // Memoize resetIdleTimer to avoid recreating the function on every render
  const resetIdleTimer = useCallback(() => {
    if (window.idleTimer) {
      clearTimeout(window.idleTimer);
    }
    window.idleTimer = setTimeout(() => {
      handleLogout();
    }, idleTimeout);
  }, [handleLogout, idleTimeout]);

  useEffect(() => {
    if (isLoggedIn) {
      window.idleTimer = setTimeout(handleLogout, idleTimeout);

      window.addEventListener('mousemove', resetIdleTimer);
      window.addEventListener('keydown', resetIdleTimer);
      window.addEventListener('scroll', resetIdleTimer);
      window.addEventListener('click', resetIdleTimer);

      return () => {
        clearTimeout(window.idleTimer);
        window.removeEventListener('mousemove', resetIdleTimer);
        window.removeEventListener('keydown', resetIdleTimer);
        window.removeEventListener('scroll', resetIdleTimer);
        window.removeEventListener('click', resetIdleTimer);
      };
    }
  }, [isLoggedIn, handleLogout, resetIdleTimer, idleTimeout]);

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <ToastContainer position="top-center" autoClose={5000} />
      {children}
    </>
  );
};

export default ProtectedRoute;
